import { IPositionMarginReport } from "@pulse-ui/codegen/generated_ts/position_management";
import { IAGPositionMarginReportDataRow } from "../../../AlgoTable.types";
import { getMargins, getParties } from "../helpers";
import { capitalizeFirstChars } from "@pulse-ui/formatting";
import { v4 as uuidv4 } from "uuid";

export const mapPositionMarginReport = (rpt: IPositionMarginReport): IAGPositionMarginReportDataRow => {
    const partiesGroup = rpt?.parties ? getParties(rpt.parties) : null;
    const marginsGroup = rpt?.margins ? getMargins(rpt.margins) : null;
    return {
        row_id: uuidv4(),
        rpt_type: rpt?.rpt_type?.toString() ? capitalizeFirstChars(rpt.rpt_type.toString().split("_")) : "-",
        current_date: rpt?.current_date ?? "-",
        total_initial_margin: rpt?.total_initial_margin?.toString() ?? "-",
        total_maintenance_margin: rpt?.total_maintenance_margin?.toString() ?? "-",
        total_unrealized_pnl: rpt?.total_unrealized_pnl?.toString() ?? "-",
        total_margin_balance: rpt?.total_margin_balance?.toString() ?? "-",
        total_margin_ratio: rpt?.total_margin_ratio?.toString() ?? "-",
        transact_time: rpt?.transact_time ?? "-",
        updated: rpt?.updated ?? "-",
        symbol: rpt?.symbol?.toString() ?? "-",
        executing_firm: partiesGroup?.executing_firm?.party_id ?? "-",
        exchange: partiesGroup?.exchange?.party_id ?? "-",
        customer_account: partiesGroup?.customer_account?.party_id ?? "-",
        intermediary: partiesGroup?.intermediary?.party_id ?? "-",
        account_wallet: partiesGroup?.account_wallet?.party_id ?? "-",
        blockchain_wallet: partiesGroup?.blockchain_wallet?.party_id ?? "-",
        maintenance_margin: marginsGroup?.maintenance_margin?.margin_amt ?? "-",
        initial_margin: marginsGroup?.initial_margin?.margin_amt ?? "-",
        margin_balance: marginsGroup?.margin_balance?.margin_amt ?? "-",
        unrealized_pnl: marginsGroup?.unrealized_pnl?.margin_amt ?? "-",
        available_balance: marginsGroup?.available_balance?.margin_amt ?? "-",
    };
}